import React, { useContext, useState } from 'react'
import { Upload, Button, Image } from 'antd'
import './index.less'
import ImgZone from './components/imgZone'
import { beforePicUpload, getRules, Data } from '../../../../utils'
import { LoadingOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { AppTypeContext } from '../../../../../spu-material-table'
import { shopLogClstag } from '../../../../../shop/log'
import { erpLogClstag } from '../../../../../erp/log'
interface Props {
  onChange?: (e: string) => void
  value?: string
  data: Data
  disabled?: boolean
  uploadImgUrl: string
}

const Uploader = (props: Props) => {
  const { value = '', onChange = () => {}, data, disabled = false } = props
  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const [imgVisible, setImgVisible] = useState(false)
  const appType = useContext(AppTypeContext) 

  const uploadButton = () => {
    return (
      <div className="upload-area">
        <div className="upload-bg" onClick={(e) => e.stopPropagation()}></div>
        {loading ? <LoadingOutlined /> : ''}
        <Button
          className="upload-btn"
          clstag="pageclick|keycount|yx_shop_1681875798915|1"
          style={{ top: !value && 11 }}
        >
          本地上传
        </Button>
        <Button
          className="upload-btn"
          style={{ top: value ? 32 : 45 }}
          onClick={(e) => {
            e.stopPropagation()
            setVisible(true)
          }}
        >
          图片空间
        </Button>
        {value && (
          <Button
            className="upload-btn"
            style={{ top: 59, left: 32, width: 18, height: 18 }}
            onClick={(e) => {
              e.stopPropagation()
              setImgVisible(true)
            }}
            clstag="pageclick|keycount|z_1682315636591|1"
          >
            <SearchOutlined />
          </Button>
        )}
      </div>
    )
  }

  const erpUploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 3, fontSize: 12 }}>上传图片</div>
      <div style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: 12 }}>{`${getRules('imgWidth', data)}*${getRules(
        'imgHeight',
        data
      )}px`}</div>
    </div>
  )

  const getUrl = (info: any) => {
    if (info.file.status === 'uploading') {
      setLoading(true)
      return
    }
    if (info.file.status === 'done') {
      setLoading(false)
      const url = appType == 'shop' ? info.file.response.data : (info.file.response.data.urlList || [])[0] || '' || ''
      onChange(url.substring(url.indexOf('jfs')))
    }
  }

  const renderUploaderDom = () => {
    if (appType === 'shop') {
      return (
        <React.Fragment>
          {!!value && (
            <div style={{ position: 'relative', width: 80, height: 80 }}>
              <img
                src={value.indexOf('jfs') === 0 ? `//img13.360buyimg.com/applylogo/${value}` : value}
                alt="avatar"
                style={{ width: '100%' }}
              />
              {!disabled && (
                <img
                  style={{ position: 'absolute', bottom: 0, width: 24, height: 24, right: 0 }}
                  src="https://img14.360buyimg.com/imagetools/jfs/t1/111051/6/26743/620/6253fa18E9af6fbcb/af155674865f0560.png"
                />
              )}
            </div>
          )}
          {!Boolean(value) && (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <PlusOutlined />
              <div style={{ marginTop: 3, fontSize: 12 }}>上传图片</div>
              <div style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: 12 }}>{`${getRules('imgWidth', data)}*${getRules(
                'imgHeight',
                data
              )}px`}</div>
            </div>
          )}
          {!disabled && uploadButton()}
        </React.Fragment>
      )
    } else {
      return value ? (
        <React.Fragment>
          <img
            src={value.indexOf('jfs') === 0 ? `//img13.360buyimg.com/applylogo/${value}` : value}
            alt="avatar"
            style={{ width: '100%' }}
          />
          {!disabled && (
            <div
              className="change-opt"
              clstag={appType === 'shop' ? shopLogClstag['changePicClick'] : erpLogClstag['changePicClick']}
            >
              <div style={{ marginTop: 19 }}>更换图片</div>
              <div>
                {getRules('imgWidth', data)}*{getRules('imgHeight', data)}px
              </div>
            </div>
          )}
        </React.Fragment>
      ) : (
        erpUploadButton
      )
    }
  }

  const imgZoneProps = {
    width: +getRules('imgWidth', data),
    height: +getRules('imgHeight', data),
    size: +getRules('imgSize', data),
    imgExtension: getRules('imgExtension', data),
    visible,
    onChange,
    setVisible,
  }

  return (
    <>
      <Upload
        name={appType == 'shop' ? 'imgFile' : 'file'}
        listType="picture-card"
        className="common-avatar-uploader"
        showUploadList={false}
        disabled={disabled}
        action={props.uploadImgUrl}
        onChange={getUrl}
        accept="image/*"
        withCredentials
        beforeUpload={(file) =>
          beforePicUpload(file, {
            imgWidth: getRules('imgWidth', data),
            imgHeight: getRules('imgHeight', data),
            imgExtension: getRules('imgExtension', data),
            imgSize: getRules('imgSize', data),
          })
        }
      >
        {renderUploaderDom()}
      </Upload>
      {appType === 'shop' ? <ImgZone {...imgZoneProps} /> : ''}
      <Image
        style={{ display: 'none' }}
        src={value.indexOf('jfs') === 0 ? `//img13.360buyimg.com/applylogo/${value}` : value}
        preview={{
          visible: imgVisible,
          src: value.indexOf('jfs') === 0 ? `//img13.360buyimg.com/applylogo/${value}` : value,
          onVisibleChange: (value) => {
            setImgVisible(value)
          },
        }}
      />
    </>
  )
}

export default Uploader
